import script from "./introPage.vue?vue&type=script&setup=true&lang=js"
export * from "./introPage.vue?vue&type=script&setup=true&lang=js"

import "./introPage.vue?vue&type=style&index=0&id=6f7c2c0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7c2c0f"]])

export default __exports__